import moment from "moment";
import {
  parseCategories,
  calPercentage,
  generateGfxCategories,
} from "../../utils/CategoryUtils";

const CATEGORIES_CIQ = ["TOT", "ARM", "LEG", "GD", "TD", "KD", "SUB"];

const GFX_CATEGORIES_CIQ = [
  {
    name: "Arm Strikes",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[1] + ".Succ",
        missed: CATEGORIES_CIQ[1] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Leg Strikes",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[2] + ".Succ",
        missed: CATEGORIES_CIQ[2] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Ground Strikes",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[3] + ".Succ",
        missed: CATEGORIES_CIQ[3] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Knockdowns",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[5] + ".Succ",
        missed: CATEGORIES_CIQ[5] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Takedowns",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[4] + ".Succ",
        missed: CATEGORIES_CIQ[4] + ".Att",
        stats: stats,
      });
    },
  },
];

function calPercentageCIQ({ missed, landed, stats, round }) {
  let missed_total = stats
    ?.filter((r) => r?.round === round || !round)
    ?.reduce((prev, curr) => {
      var value = missed?.split(".").reduce((a, b) => a?.[b], curr);

      return prev + (value || 0);
    }, 0);
  let landed_total = stats
    ?.filter((r) => r?.round === round || !round)
    ?.reduce((prev, curr) => {
      var value = landed?.split(".").reduce((a, b) => a?.[b], curr);
      return prev + (value || 0);
    }, 0);
  let output = (landed_total || 0) + "/";

  output += (missed_total || 0) + (landed_total || 0);

  return output;
}
export class Clock {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
    vizCommand,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.vizCommand = vizCommand;
    this.name = "CLOCK";
    this.scene = "Clock";
    this.data = [];
    this.page = 122;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options });

    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    await this.updateData({ options });

    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    if (options.type === "END") {
      if (this.onAir) {
        this.sendAnimateOff({ page: this.page });
      }
    } else {
      this.sendAnimateOff({ page: this.page });
    }
    this.onAir = false;
  }

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  async updateData({ options }) {
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
    
      xml.payload.field.find((item) => {
        return item.attr.name === "0101"; // Number
      }).value =
        options.game?.home_fighter?.short_name?.toUpperCase() ||
        options.game?.home_fighter?.last_name?.toUpperCase() ||
        "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0201"; // Number
      }).value =
        options.game?.away_fighter?.short_name?.toUpperCase() ||
        options.game?.away_fighter?.last_name?.toUpperCase() ||
        "";

      let period = options.period;

      await this.vizCommand({ viz_command: "10 MAIN_SCENE*FUNCTION*DataPool*Data SET ROUND_NUMBER=" + period.number +";" });
      await this.vizCommand({ viz_command: "10 MAIN_SCENE*FUNCTION*DataPool*Data SET ROUND_MAX=" + options.game?.number_of_rounds +";" });
      let pauseTime = 0;

      period.pause &&
        period.pause.forEach((pause) => {
          if (pause.end) {
            pauseTime += pause.end - pause.start;
          }
        });
      let latestPause = period.pause && period.pause[period.pause.length - 1];
      if (latestPause && latestPause.end) {
        latestPause = null;
      }
      let time = moment.duration(
        ((latestPause && latestPause.start) || Date.now()) -
          period.kick_off -
          pauseTime
      );

      let round_minutes =
        options?.game?.round_minutes !== undefined ||
        options?.game?.round_minutes !== null
          ? options?.game?.round_minutes
          : 5;

      let count_down = moment.duration(
        Math.max(0, 1000 * 60 * round_minutes - time.asMilliseconds())
      );

      let seconds =
        count_down.seconds() +
        count_down.minutes() * 60 +
        count_down.hours() * 60 * 60;
      seconds = Math.max(0, seconds);

      if (!latestPause) {
          await this.vizCommand({ viz_command: `10 CLOCK0*TIME SET  ${seconds}.000`});
          await this.vizCommand({ viz_command: "10 CLOCK0*DIRECTION SET DOWN"});
          await this.vizCommand({ viz_command: "10 CLOCK0*LIMIT SET 0.000"});
          await this.vizCommand({ viz_command: "10 CLOCK0 START"});
      } else {

          await this.vizCommand({ viz_command: `10 CLOCK0*TIME SET  ${seconds}.000`});
          await this.vizCommand({ viz_command: "10 CLOCK0*DIRECTION SET DOWN"});
          await this.vizCommand({ viz_command: "10 CLOCK0*LIMIT SET 0.000"});
          await this.vizCommand({ viz_command: "10 CLOCK0 STOP"});;
      }

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  async update({ options }) {
    if (options.type === "PAUSE" || options.type === "RESUME") {
      let xml = await this.getVizPage({ page: this.page }).catch((err) => {
        console.log(err);
      });
      if (xml) {
        let period = options.period;

      let pauseTime = 0;

      period.pause &&
        period.pause.forEach((pause) => {
          if (pause.end) {
            pauseTime += pause.end - pause.start;
          }
        });
      let latestPause = period.pause && period.pause[period.pause.length - 1];
      if (latestPause && latestPause.end) {
        latestPause = null;
      }
      let time = moment.duration(
        ((latestPause && latestPause.start) || Date.now()) -
          period.kick_off -
          pauseTime
      );

      let round_minutes =
        options?.game?.round_minutes !== undefined ||
        options?.game?.round_minutes !== null
          ? options?.game?.round_minutes
          : 5;

      let count_down = moment.duration(
        Math.max(0, 1000 * 60 * round_minutes - time.asMilliseconds())
      );

      let seconds =
        count_down.seconds() +
        count_down.minutes() * 60 +
        count_down.hours() * 60 * 60;
      seconds = Math.max(0, seconds);

        if (options.type === "PAUSE") {
          // xml.payload.field.find((item) => {
          //   return item.attr.name === "1007"; // start clock
          // }).value = "STOP";
        } else if (options.type === "RESUME") {
          await this.vizCommand({ viz_command: `10 CLOCK0*TIME SET  ${seconds}.000`});
          await this.vizCommand({ viz_command: "10 CLOCK0*DIRECTION SET DOWN"});
          await this.vizCommand({ viz_command: "10 CLOCK0*LIMIT SET 0.000"});
          await this.vizCommand({ viz_command: "10 CLOCK0 START"});
        }

        if (options.type === "PAUSE") {
          await this.vizCommand({ viz_command: "10 CLOCK0 STOP" });
        } else if (options.type === "RESUME") {
          await this.vizCommand({ viz_command: "10 CLOCK0 CONT" });
        }

        await this.updateVizPage({
          page: this.page,
          data: xml,
          escape: false,
        }).catch((err) => {
          console.log(err);
        });
      }
    }
  }
}
